exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* sizes */\n/* colors */\n.HeroTransitionSection__hero-transition__2XpUE {\n  padding: 24vw 20px;\n  text-align: center; }\n  .HeroTransitionSection__hero-transition__statement__2aU2E p {\n    font-size: 0.9rem;\n    color: #ACB4BB;\n    margin: 0 auto; }\n  @media (min-width: 769px) {\n    .HeroTransitionSection__hero-transition__2XpUE {\n      padding: 12vw 30px; }\n      .HeroTransitionSection__hero-transition__2XpUE .HeroTransitionSection__hero-transition__statement__2aU2E p {\n        font-size: 1.5rem;\n        line-height: 36px;\n        max-width: 38em; } }\n", ""]);

// exports
exports.locals = {
	"hero-transition": "HeroTransitionSection__hero-transition__2XpUE",
	"hero-transition__statement": "HeroTransitionSection__hero-transition__statement__2aU2E"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/components/organisms/HeroTransitionSection/HeroTransitionSection.scss
// module id = 170
// module chunks = 0